/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ows-abacus-event
 * OpenAPI spec version: 1.0.0
 */
import type {
  AbacusEventResponse,
  AbacusEventsResponse,
  CreateAbacusEventBody,
  CreateAbacusEventHeaders,
  DataloadAbacusEventsHeaders,
  DataloadAbacusEventsResponse,
  GetAbacusEventHeaders,
  GetAbacusEventPathParameters,
  GetAbacusEventsBody,
  GetAbacusEventsByTargetHeaders,
  GetAbacusEventsByTargetPathParameters,
  GetHealthHeaders,
  GetPaymentGroupPaymentApprovalCountHeaders,
  GetPaymentGroupPaymentApprovalCountPathParameters,
  HealthResponse,
  PaymentGroupPaymentApprovalCountResponse,
  RollbackAbacusEventBody,
  RollbackAbacusEventHeaders,
} from "./types";
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];
/**
 * Generated by @abacus/api-client-generator
 * Do not edit manually.
 */
import Axios, { type AxiosInstance, type AxiosRequestConfig } from "axios";

import { type Logger, type HeaderProvider } from "@abacus/common";

import { type Throttler } from "@abacus/throttlers";

import { ApiResponse } from "./common";

export interface ApiConfig {
  auth?: HeaderProvider;
  axios?: AxiosInstance;
  baseUrl?: string;
  logger?: Logger;
  throttler?: Throttler;
}

export class OwsAbacusEventClient {
  auth?: HeaderProvider;
  axios: AxiosInstance;
  baseUrl: string;
  logger?: Logger;
  throttler?: Throttler;

  constructor(config?: ApiConfig) {
    this.auth = config?.auth;
    this.axios = config?.axios ?? Axios.create();
    this.baseUrl = config?.baseUrl ?? `https://localhost:8080`;
    this.logger = config?.logger;
    this.throttler = config?.throttler;
  }

  async _fetch<T>(
    config: AxiosRequestConfig,
    options?: AxiosRequestConfig,
  ): Promise<ApiResponse<T>> {
    // On request
    config = await this._onRequest(config, options);
    // Make request
    const response = await this.axios(config);
    // Get data
    const data = response.data;
    const headers = response.headers as Record<string, string>;
    // Return response
    return { data, headers, status: response.status };
  }

  private async _getHeaders(
    headers?: Record<string, string>,
  ): Promise<Record<string, string>> {
    return {
      ...(await this.auth?.getHeaders()),
      ...headers,
    };
  }

  private async _onRequest(
    config: AxiosRequestConfig,
    options?: AxiosRequestConfig,
  ): Promise<AxiosRequestConfig> {
    // Throttle the request
    await this.throttler?.wait();
    // Update config
    config = { ...config, ...options };
    // Add base URL
    config.baseURL ??= this.baseUrl;
    // Add headers
    const headers = config.headers as Record<string, string>;
    config.headers = await this._getHeaders(headers);
    // Log the request
    this.logger?.debug(`Requesting ${config.method} ${config.url}`);
    return config;
  }

  createAbacusEvent(
    createAbacusEventBody: CreateAbacusEventBody,
    headers?: CreateAbacusEventHeaders,
    options?: SecondParameter<typeof this._fetch>,
  ) {
    {
      return this._fetch<AbacusEventResponse>(
        {
          url: `/abacus-event/`,
          method: "POST",
          headers: { "Content-Type": "application/json", ...headers },
          data: createAbacusEventBody,
        },
        options,
      );
    }
  }

  getAbacusEvent(
    { abacusEventId }: GetAbacusEventPathParameters,
    headers?: GetAbacusEventHeaders,
    options?: SecondParameter<typeof this._fetch>,
  ) {
    {
      return this._fetch<AbacusEventResponse>(
        { url: `/abacus-event/${abacusEventId}`, method: "GET", headers },
        options,
      );
    }
  }

  getAbacusEventsByTarget(
    { targetType, targetId }: GetAbacusEventsByTargetPathParameters,
    headers?: GetAbacusEventsByTargetHeaders,
    options?: SecondParameter<typeof this._fetch>,
  ) {
    {
      return this._fetch<AbacusEventsResponse>(
        {
          url: `/abacus-event/${targetType}/${targetId}/`,
          method: "GET",
          headers,
        },
        options,
      );
    }
  }

  dataloadAbacusEvents(
    getAbacusEventsBody: GetAbacusEventsBody,
    headers?: DataloadAbacusEventsHeaders,
    options?: SecondParameter<typeof this._fetch>,
  ) {
    {
      return this._fetch<DataloadAbacusEventsResponse>(
        {
          url: `/abacus-event/dataloader`,
          method: "POST",
          headers: { "Content-Type": "application/json", ...headers },
          data: getAbacusEventsBody,
        },
        options,
      );
    }
  }

  getPaymentGroupPaymentApprovalCount(
    {
      paymentGroupPaymentId,
    }: GetPaymentGroupPaymentApprovalCountPathParameters,
    headers?: GetPaymentGroupPaymentApprovalCountHeaders,
    options?: SecondParameter<typeof this._fetch>,
  ) {
    {
      return this._fetch<PaymentGroupPaymentApprovalCountResponse>(
        {
          url: `/abacus-event/payment-group-payment/${paymentGroupPaymentId}/approval-count/`,
          method: "GET",
          headers,
        },
        options,
      );
    }
  }

  rollbackAbacusEvent(
    rollbackAbacusEventBody: RollbackAbacusEventBody,
    headers?: RollbackAbacusEventHeaders,
    options?: SecondParameter<typeof this._fetch>,
  ) {
    {
      return this._fetch<AbacusEventResponse>(
        {
          url: `/abacus-event/rollback/`,
          method: "PUT",
          headers: { "Content-Type": "application/json", ...headers },
          data: rollbackAbacusEventBody,
        },
        options,
      );
    }
  }

  getHealth(
    headers?: GetHealthHeaders,
    options?: SecondParameter<typeof this._fetch>,
  ) {
    {
      return this._fetch<HealthResponse>(
        { url: `/hello/`, method: "GET", headers },
        options,
      );
    }
  }
}
